import React from "react";
import { Box } from "@mui/material";
import { QrReader } from "react-qr-reader";
export default function Scan({ set_uuid }) {
    return (
        <Box sx={{ width: "100%" }}>
            <QrReader
                key="environment"
                onResult={(result, error) => {
                    if (result) {
                        set_uuid(result?.text);
                    }
                }}
                constraints={{ facingMode: "environment" }}
            />
        </Box>
    );
}
